import { render, staticRenderFns } from "./portador.vue?vue&type=template&id=cfe262a2"
import script from "./portador.vue?vue&type=script&lang=js"
export * from "./portador.vue?vue&type=script&lang=js"
import style0 from "./portador.vue?vue&type=style&index=0&id=cfe262a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports